module.exports = __webpack_public_path__ + "static/sql-server-2005-tsql-recipes-c4cbc417fbbb90a7b85f5be36b6f1387.jpg";